import { Roles } from '@/utils/roles';
import { FeaturesEnum } from '@utils/features';
import { TablesListPage, TablesCreatePage } from '../elements';
import { pathJoin } from '../paths';
import { resolvePathRoute } from '../generate-route';

const ROOT = 'tables';
export const paths = (root: string): any => ({
  root: {
    path: pathJoin(root, [ROOT]),
    title: ROOT,
    isFoodCompany: true,
    feature: FeaturesEnum.TABLES,
    guard: [Roles.ADMIN],
  },
  list: {
    path: pathJoin(root, [ROOT, 'list']),
    // element: TablesListPage,
    element: TablesCreatePage,
    guard: [Roles.ADMIN],
    params: undefined,
    feature: FeaturesEnum.TABLE_LIST,
    title: 'list',
    show: true,
  },
});

export const pathTables = (root: string) => ({
  [ROOT]: resolvePathRoute(paths(root)),
});
